import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-angle-up",
  "use": "icon-s-angle-up-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-angle-up\"><path transform=\"rotate(90 0 22.021)scale(-1 1)\" fill-rule=\"evenodd\" d=\"M17.0212098 11.0212098 6.37604854 22.0433063 4.9566937 20.6239515 14.1825002 11.0212098 4.9566937 1.44056467 6.37604854.0212098316z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol